import React from "react";
import {Link} from "react-router-dom";
import {SLOT_DESCRIPTIONS} from "../../common/utils";

const SlotItem = ({slot}) => {
    if (slot !== null) {
        if (slot.scheduled_act === null) {
            return (
                <span key={slot.id}>{slot.slot_def + ": " + SLOT_DESCRIPTIONS[slot.slot_def]} - Available</span>
            );
        }
        else {
            return (
                <span key={slot.id}>{slot.slot_def + ": " + SLOT_DESCRIPTIONS[slot.slot_def]} - Scheduled to host <Link to={`/acts/${slot.scheduled_act.id}`} reloadDocument="true">{slot.scheduled_act.name}</Link></span>
            );
        }
    }
};

export default SlotItem;
